class FreeShippingBar extends HTMLElement {
  constructor() {
    super();
    this.innerHTML = `
      <div class="free-shipping-message" id="messageText"></div>
      <div class="free-shipping-container">
        <div class="free-shipping-bar" id="progressBar" style="width: 0%;"></div>
      </div>
      <div class="free-shipping-slider-title" id="freeShippingSliderTitle" class="free-shipping-slider-title"></div>
      <div class="free-shipping-slider" id="freeShippingSlider" style="display:none"></div>
    `;

    this.addEventListener('click', (e) => {
      if (e.target.classList.contains('free-shipping-slider-add-btn')) {
        const variantId = e.target.getAttribute('data-variant-id');
        if (variantId) this.addToCart(variantId);
      }
    });
    this.cart = document.querySelector('cart-drawer');
  }

  connectedCallback() {
    this.animateProgress();
  }

  attributeChangedCallback() {
    this.animateProgress();
  }

  static get observedAttributes() {
    return [
      'data-current',
      'data-max',
      'data-message-incomplete',
      'data-message-complete',
      'data-bar-color',
      'data-products',
      'data-slider-title',
    ];
  }

  addToCart(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: {
          _free_shipping_crossell: true,
        },
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'freeshipping-crossell', cartData: response });

        return fetch(`${routes.cart_url}?section_id=cart-drawer`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const selectors = ['cart-drawer-items', '.cart-drawer__footer', 'free-shipping-bar'];
            for (const selector of selectors) {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
              }
            }

            fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const selectors = ['.cart-count-bubble'];
                for (const selector of selectors) {
                  const targetElement = document.querySelector(selector);
                  const sourceElement = html.querySelector(selector);
                  if (targetElement && sourceElement) {
                    targetElement.replaceWith(sourceElement);
                  }
                }
              })
              .catch((e) => {
                console.error(e);
              });
          })
          .catch((e) => {
            console.error(e);
          });
      })
      .catch((err) => console.error('Error al agregar al carrito:', err))
      .finally(() => {
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      });
  }

  animateProgress() {
    const current = parseFloat(this.getAttribute('data-current')) || 0;
    const max = parseFloat(this.getAttribute('data-max')) || 55;
    const messageIncomplete =
      this.getAttribute('data-message-incomplete') || 'Faltan {remaining_amount}€ para envío gratis';
    const messageComplete = this.getAttribute('data-message-complete') || 'Envío gratis conseguido!';
    const barColor = this.getAttribute('data-bar-color') || 'linear-gradient(90deg, #4caf50, #81c784)';

    const progressBar = this.querySelector('#progressBar');
    const messageText = this.querySelector('#messageText');
    const sliderTitle = this.querySelector('#freeShippingSliderTitle');
    const slider = this.querySelector('#freeShippingSlider');

    progressBar.style.background = barColor;

    if (current >= max) {
      this.classList.add('visibility-hidden');
    } else {
      const missing = (max - current).toFixed(2);
      messageText.textContent = messageIncomplete.replace('{remaining_amount}', missing.replace('.', ','));
    }

    progressBar.style.transition = 'none';
    progressBar.style.width = '0%';

    progressBar.offsetWidth;

    progressBar.style.transition = 'width 1.4s cubic-bezier(0.4, 0, 0.2, 1)';
    const percent = current >= max ? 100 : (current / max) * 100;
    progressBar.style.width = percent + '%';

    slider.style.display = 'flex';
    this.renderSlider();
    sliderTitle.textContent = this.getAttribute('data-slider-title');
    if (!this.getAttribute('data-products')) {
      slider.style.display = 'none';
      sliderTitle.style.display = 'none';
    }
  }

  renderSlider() {
    const slider = this.querySelector('#freeShippingSlider');
    const data = this.getAttribute('data-products');
    let products = [];

    try {
      products = JSON.parse(data);
    } catch (e) {
      return;
    }

    if (!Array.isArray(products)) {
      slider.style.display = 'none';
      return;
    }

    slider.innerHTML = products
      .map(
        (prod) => `
      <div class="free-shipping-slider-item">
        <img src="${prod.featured_image}" alt="${prod.variants[0].name}">
        <div class="free-shipping-slider-data">
          <div class="free-shipping-slider-product-title" title="${prod.variants[0].name}">${
          prod.variants[0].name
        }</div>
          <div class="free-shipping-slider-product-price">${prod.variants[0].price / 100}€</div>
          <button class="button button--primary free-shipping-slider-add-btn" data-variant-id="${
            prod.variants[0].id
          }">Añadir</button>
        </div>
      </div>
    `
      )
      .join('');
  }

  setProgress(current, max) {
    this.setAttribute('data-current', current);
    this.setAttribute('data-max', max);
  }
}

customElements.define('free-shipping-bar', FreeShippingBar);
